
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[name]",
      function () {
        return require("private-next-pages/docs/[name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/[name]"])
      });
    }
  